import './css/App.css';

import githubSvg from './css/github.svg';
import linkedinSvg from './css/linkedin.svg';
import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";
import { Analytics } from "@vercel/analytics/react"

import Home from './home'
import Projects from './projects'
import Contact from './contact'
import Header from './header';
import Waves from './waves';




export default function App() {
return (

  <Router>
    <Analytics/> 
      <div className='app'>
        <Header />
      <div className="background">
        <Waves />
      </div>


      <Routes>
          <Route exact path="/" element={<Home />} />
          <Route path="/projects" element={<Projects />} />
          <Route
              path="/contact"
              element={<Contact />}
          />
      </Routes>

    </div>
    </Router>





)
}

